import "can/construct/";
import _forEach from "lodash/forEach";
import SearchBar from "./admin-modules/search-bar.adm";
import LeftSidebar from "./admin-modules/left-sidebar.adm";
import RightSidebar from "./admin-modules/right-sidebar.adm";
import NavBar from "./admin-modules/navbar.adm";
import Browser from "./admin-modules/browser.adm";
import SkinChanger from "./admin-modules/skin-changer.adm";
import TasksAndNotificationScroll from "./admin-modules/tasks-and-notifications-scroll.adm";
import DropdownMenu from "./admin-modules/dropdown-menu.adm";
import Input from "./admin-modules/input.adm";


// Initiate `VtAdmin` namespace
can.Construct( "VtAdmin.AppConstructor", {}, {});

VtAdmin.Modules = {
    browser: Browser,
    search: SearchBar,
    leftSidebar: LeftSidebar,
    rightSidebar: RightSidebar,
    navbar: NavBar,
    skinChanger: SkinChanger,
    taskAndNotificationScroll: TasksAndNotificationScroll,
    dropdownMenu: DropdownMenu,
    input: Input,

    enable: function( $el ) {
        "use strict";

        let _this = this;

        // Active `browser` controls module
        _this.browser.activate();

        // Activate `search` bar module
        _this.search.init( $el ).activate();

        // Activate `left side bar` navigation menu module
        _this.leftSidebar.init( $el ).activate();

        // Activate `right side bar` options menu module
        _this.rightSidebar.init( $el ).activate();

        // Activate `navigation bar` module
        // This module controls the `show/hide` of left sidebar navigation menu
        _this.navbar.init( $el ).activate();

        // Activate `skin` changer module
        _this.skinChanger.init( $el ).activate();

        // Activate `tasks` and `notifications` dropdown module
        _this.taskAndNotificationScroll.init( $el ).activate();

        // Activate `dropdown menu` module
        _this.dropdownMenu.init( $el ).activate();

        // Activate `input` module
        _this.input.init( $el ).activate();
    },

    set: function( $el, modules ) {
        "use strict";

        let _this = this;

        _forEach( modules, module => {
            if ( module === "browser" ) {
                _this[ module ].activate();
            } else {
                _this[ module ].init( $el ).activate();
            }
        });
    }
};

VtAdmin.options = {
    colors: {
        red: "#F44336",
        pink: "#E91E63",
        purple: "#9C27B0",
        deepPurple: "#673AB7",
        indigo: "#3F51B5",
        blue: "#2196F3",
        lightBlue: "#03A9F4",
        cyan: "#00BCD4",
        teal: "#009688",
        green: "#4CAF50",
        lightGreen: "#8BC34A",
        lime: "#CDDC39",
        yellow: "#ffe821",
        amber: "#FFC107",
        orange: "#FF9800",
        deepOrange: "#FF5722",
        brown: "#795548",
        grey: "#9E9E9E",
        blueGrey: "#607D8B",
        black: "#000000",
        white: "#ffffff"
    },

    leftSideBar: {
        scrollColor: "rgba(0,0,0,0.5)",
        scrollWidth: "12px",
        scrollAlwaysVisible: false,
        scrollBorderRadius: "0",
        scrollRailBorderRadius: "0"
    },

    dropdownMenu: {
        effectIn: "fadeIn",
        effectOut: "fadeOut"
    }
};
